<div class="wrapper">
  <div class="sidebar">
    <app-sidebar-cmp></app-sidebar-cmp>
    <div class="sidebar-background"></div>
  </div>
  <div class="main-panel">
    <app-navbar-cmp></app-navbar-cmp>
    <doc-main-panel [sourceApp]="configurations.documentationInput.sourceApp" [pageId]="configurations.documentationInput.pageId"
        [editEnabled]="configurations.documentationInput.editEnabled" [sectionId]="configurations.documentationInput.sectionId"
        [showPanel]="configurations.documentationInput.showPanel"
        (DocumentationLoaded)="onDocumentation_Loaded($event)"></doc-main-panel>
    <router-outlet></router-outlet>
  </div>
</div>